import {TERRAIN_TOKENS} from '../../constants/tokens';

/**
 * Стоит ли отряд на жетоне, а не на пустой ячейке.
 *
 * Жетоны на поле нарисованы в псевдо-3D и подняты над центром ячейки, поэтому
 * отряд поверх жетона тоже поднимается — вместе со всем, что к нему привязано
 * (см. getUnitShiftY в HexGridRenderer). На пустой ячейке подниматься нечему.
 *
 * Решается по СЫРОМУ токену ячейки, как и пустота в остальной отрисовке:
 * разрушенное строение может выглядеть пустым, но жетон под ним остается.
 * Море — не жетон: оно помечает неигровую часть сетки и не рисуется вовсе.
 *
 * @param {string|undefined|null} token - токен ячейки из shared.hexes
 * @returns {boolean}
 */
export const checkIfUnitStandsOnBuilding = (token) =>
  Boolean(token) && token !== TERRAIN_TOKENS.SEA;
